import { mapGetters, mapMutations } from 'vuex';
import $ from 'jquery';

export default {
  name: 'NoteSideBar',

  computed: {
    ...mapGetters('Notes/NoteDetail', {
      mg_noteBookDetail: 'noteBookDetail',
      mg_currentBullet: 'currentBullet',
    }),
  },

  methods: {
    ...mapMutations('Notes/NoteDetail', {
      mm_SET_READING_IDX: 'SET_READING_IDX',
      mm_SET_BULLET_IDX: 'SET_BULLET_IDX',
    }),

    selectReading(readingIdx) {
      this.mm_SET_READING_IDX(readingIdx);
    },

    selectBullet(bulletIdx) {
      this.mm_SET_BULLET_IDX(bulletIdx);
    },

    showFirstReading() {
      const navReadingCollapse0 = this.$refs.navReadingCollapse[0];
      if (navReadingCollapse0) {
        $(navReadingCollapse0).collapse('show');
      }
    },
  },
};
